// extracted by mini-css-extract-plugin
module.exports = {"designManagerBubbleDiv":"_549fb78f","tooltipWrapper":"_d9baa6ad","bubble":"_afe55d5","icon":"_a39efa20","printLink":"_f6f330ba","designManagerBubble":"_75ec1034 _afe55d5"};